const root = process.env.REACT_APP_CMS_AUTH;
const rutasAuthCMS = { 
    auth : root +  "/connect/token"
}

export default rutasAuthCMS;